import { css } from '@sitebase/emotion';

// COLORS - Primary scheme
export var colorPrimary600 = '#000c24';
export var colorPrimary500 = '#00143c';
export var colorPrimary400 = '#162751';
export var colorPrimary300 = '#2e4068';
export var colorPrimary200 = '#7383a6';
export var colorPrimary100 = '#96a3c4';
export var colorPrimary50 = '#adc9ff';
export var colorPrimary40 = '#d7e3ff';
export var colorPrimary30 = '#ebf1ff';

// COLORS - Secondary scheme
export var colorSecondary600 = '#e6e504';
export var colorSecondary500 = '#faff05';
export var colorSecondary400 = '#f1f004';
export var colorSecondary300 = '#e6e504';

// COLORS - Accent scheme
export var colorAccent500 = '#00afff';
export var colorAccent400 = '#009ae0';
export var colorAccent300 = '#0085c2';

// COLORS - Monochrome scheme
export var colorMonochromeBlack = '#000';
export var colorMonochromeWhite = '#fff';
export var colorMonochrome400 = '#e6e8ed';
export var colorMonochrome300 = '#cdd2dc';

// COLORS - Success scheme
export var colorSuccess500 = '#08d228';
export var colorSuccess400 = '#07b522';
export var colorSuccess300 = '#06971d';

// COLORS - Warning scheme
export var colorWarning500 = '#eb7400';
export var colorWarning400 = '#d76a00';
export var colorWarning300 = '#c26000';

// COLORS - Error scheme
export var colorError500 = '#f23c3e';
export var colorError400 = '#f01f22';
export var colorError300 = '#e20f11';

// COLORS
export var colorYellow600 = '#e6e504';
export var colorYellow500 = '#faff05';
export var colorLightBlue500 = '#00afff';
export var colorGreen500 = '#08d228';
export var colorOrange500 = '#eb7400';
export var colorRed500 = '#f23c3e';

// TYPOGRAPHY - Font family
export var fontFamilyDefault = 'Verdana, sans-serif';

// TYPOGRAPHY - Font size
export var fontSizeDesktopH1 = '20px';
export var fontSizeDesktopH2 = '18px';
export var fontSizeDesktopH3 = '16px';
export var fontSizeDesktopH4 = '13px';
export var fontSizeDesktopH5 = '12px';
export var fontSizeDesktopH6 = '11px';
export var fontSizeDesktopParagraph = '12px';

export var fontSizeMobileH1 = '14px';
export var fontSizeMobileH2 = '13px';
export var fontSizeMobileH3 = '12px';
export var fontSizeMobileH4 = '11px';
export var fontSizeMobileParagraph = '12px';

// TYPOGRAPHY - Line heights
export var lineHeightDesktopH1 = '24px';
export var lineHeightDesktopH2 = '22px';
export var lineHeightDesktopH3 = '20px';
export var lineHeightDesktopH4 = '16px';
export var lineHeightDesktopH5 = '16px';
export var lineHeightDesktopH6 = '12px';
export var lineHeightDesktopParagraph = '16px';

export var lineHeightMobileH1 = '18px';
export var lineHeightMobileH2 = '16px';
export var lineHeightMobileH3 = '16px';
export var lineHeightMobileH4 = '13px';
export var lineHeightMobileParagraph = '16px';

export var lineHeight = 1.33;

// SIZES
export var sizeXtiny = '2px';
export var sizeTiny = '4px';
export var sizeSmall = '6px';
export var sizeNormal = '8px';
export var sizeBase = '12px';
export var sizeLarge = '16px';
export var sizeXlarge = '24px';

// SHADOWS
// --

// BASIC RULES
export var animationDuration = '0.33s';
export var radiusDefaultSize = '2px';

// RESETS
export var fontDefaults = /*#__PURE__*/css('color:', colorPrimary500, ';font-family:', fontFamilyDefault, ';font-size:', sizeBase, ';line-height:', lineHeight, ';');

export var rawButton = /*#__PURE__*/css('background-color:transparent;border:none;margin:0;padding:0;&:focus{outline:none;}');

// HELPERS
export var px = function px(value) {
  return value + 'px';
};